import { defineStore } from 'pinia';

const activePageUrlParam = 'ap';
const filterIdsUrlParam = 'filterIds';
const sliderMinUrlParam = 'smin';
const sliderMaxUrlParam = 'smax';

export const useProjectListStore = defineStore('project-list', {
    state: () => ({
        filters: [],
        pages: [],
        activePage: { id: 0, name: 'Galleri' },
        sliderInitialValues: [],
        sliderValues: []
    }),
    actions: {
        // Init from url
        initPages(pages) {
            this.pages = pages;
            const activePageId = this.getUrlSegment(activePageUrlParam);

            if (activePageId == 0 || activePageId == 1 || activePageId == 2) {
                this.activePage = this.pages[activePageId];
            } else {
                this.activePage = this.pages[0];
                this.updateActivePageUrlSegment();
            }
        },
        initFilters(filterResult, filterType) {
            var filterIds = this.getUrlSegment(filterIdsUrlParam);

            if (filterIds !== null) {
                var array = filterIds.split(",");
                array.forEach((filterId) => {
                    var tag = filterResult.find((x) => x?.id === decodeURIComponent(filterId));
                    if (tag !== undefined) {
                        this.addFilter(tag.id, tag.name, filterType, false);
                    }
                });
            }
        },
        initSliderValues(min, max) {
            this.sliderInitialValues = [min, max];
            let sliderMinValue = this.getUrlSegment(sliderMinUrlParam);
            let sliderMaxValue = this.getUrlSegment(sliderMaxUrlParam);

            if (sliderMinValue !== null && sliderMaxValue !== null) {
                var array = JSON.parse('[' + sliderMinValue + ',' + sliderMaxValue + ']');
                this.sliderValues = array;
            } else {
                this.sliderValues = this.sliderInitialValues;
                this.updateSliderUrlSegment();
            }
        },

        // Navigation
        navigate(page) {
            this.activePage = page;
            this.updateActivePageUrlSegment();
        },
        isActivePage(link) {
            return this.activePage?.name === link.title;
        },

        // Filter actions
        filterByTimePeriod(values) {
            if (this.sliderValues != values) {
                this.sliderValues = values;
                this.updateSliderUrlSegment();
            }
        },
        toggleFilter(id, name, filterType) {
            var exists = this.filters.find((x) => x.id === id) ? true : false;
            if (exists) {
                this.removeFilter(id);
            } else {
                this.addFilter(id, name, filterType);
            }
        },
        addFilter(id, name, filterType, update = true) {
            var exists = this.filters.find((x) => x.id === id) ? true : false;
            if (!exists) {
                this.filters.push({
                    id,
                    name,
                    filterType
                });
            }
            if (update) {
                this.updateFiltersUrlSegment();
            }
        },
        isActiveFilter(id) {
            return this.filters.find((x) => x.id === id) ? true : false;
        },
        resetFilters() {
            this.filters = [];
            this.sliderValues = this.sliderInitialValues;
            this.updateFiltersUrlSegment();
            this.updateSliderUrlSegment();
        },
        removeFilter(id) {
            this.filters = this.filters.filter((x) => x.id != id);
            this.updateFiltersUrlSegment();
        },

        // Url segments
        getUrlSegment(name) {
            var hash = window.location.hash.slice(1);

            var resultArray = hash.split('&').reduce(function (res, item) {
                var parts = item.split('=');
                parts[0] = parts[0].replace('?', '');
                res[parts[0]] = parts[1];
                return res;
            }, {});

            var result = resultArray[name] ?? null;
            return result;
        },
        updateActivePageUrlSegment() {
            var str = window.location.hash;
            str = this.replaceQueryParam(activePageUrlParam, this.activePage?.id, str);
            window.location.hash = str;
        },
        updateFiltersUrlSegment() {
            var str = window.location.hash;
            var filterIds = this.filters.map((f) => f.id);
            str = this.replaceQueryParam(filterIdsUrlParam, filterIds.toString(), str);
            window.location.hash = str;
        },
        updateSliderUrlSegment() {
            var str = window.location.hash;
            str = this.replaceQueryParam(sliderMinUrlParam, this.sliderValues[0], str);
            str = this.replaceQueryParam(sliderMaxUrlParam, this.sliderValues[1], str);
            window.location.hash = str;
        },
        replaceQueryParam(param, newval, search) {
            var regex = new RegExp('([?;&])' + param + '[^&;]*[;&]?');
            var query = search.replace(regex, '$1').replace(/&$/, '');

            return (query.length > 2 ? query + '&' : '?') + (newval ? param + '=' + newval : '');
        }
    }
});
